var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelfEmployedFormBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 699,
    height: 580,
    viewBox: "0 0 699 580",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.137 579.417L82.1694 233.128L-286.343 409.707L-67.5519 94.1248L-432.585 -121.649L61.7979 -30.0702L134.648 -312.734L217.382 -53.1711L574.348 -168.921L322.325 36.2367L698.616 164.041L326.278 176.26L480.814 423.288L240.63 254.596L111.137 579.417Z",
    fill: "url(#paint0_linear_829_362)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_829_362",
    x1: 675.812,
    y1: 157.25,
    x2: -130.811,
    y2: -150.968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#115EF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#115EF3",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfEmployedFormBg);
export default __webpack_public_path__ + "static/media/self-employed-form-bg.9f43d923b69398ea2cd44c3e192be120.svg";
export { ForwardRef as ReactComponent };